import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { registerSW } from "virtual:pwa-register";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA
const updateSW = registerSW({
  onNeedRefresh() {
    // Auto-refresh when new content is available
    updateSW(true);
  },
  onOfflineReady() {
    console.log("App is ready for offline usage");
  },
});
